import { ApiProperty } from "@nestjs/swagger";
import { MeasurementDataDTO } from "./measurement-dto";
import { TrimCardStatusEnum } from "@project-management-system/shared-models";

export class ImageUploadDTO {
    @ApiProperty()
    id: number

    @ApiProperty()
    status: TrimCardStatusEnum

}
